import React from "react";

/** Bannière technique masquée — expérience utilisateur GSD (BT-AUTH-SHELL-001). */
export function DataSourceBanner() {
  return null;
}
